import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Dispatch } from 'redux'

import TechnicalSkillsAccordian from './technical_skills/TechnicalSkillsAccordian'
import { updatePageTitle } from '../../redux/active_page/actions'

import './skills.css';
import InterpersonalSkills from './interpersonal_skills/InterpersonalSkills'

const SkillsPage = () => {

	const dispatch: Dispatch = useDispatch()
	useEffect(() => {
		dispatch(updatePageTitle("Skills"));
	}, [])
	return (
		<div className="vertical-flow center s-center">
			<div className="skills">
				<div className="t-skills">
					<h1>Technical Skills</h1>
					<div className="row">
						<TechnicalSkillsAccordian />
					</div>
				</div>
				<div className="p-skills">
					<h1>Soft Skills</h1>
					<div className='row'>
						<InterpersonalSkills />
					</div>
				</div>
			</div>
		</div>
	)
}

export default SkillsPage